import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { FinancialItemPriceListingImportFileHdrContainer } from '../../../../../../models';
import { ApiVisa, Core2Config } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class FinancialItemPriceListingImportFileHdrService extends BaseApiTemplateService<FinancialItemPriceListingImportFileHdrContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-items/price-listing/import-file-hdr';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-items/price-listing/import-file-hdr' + '/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-items/price-listing/import-file-hdr' + '/backoffice-ep';
    this.httpClient = http;
  }

  public uploadImportFile(formData: FormData, visa: ApiVisa, add_to_queue?: boolean) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '?add_to_queue=' + add_to_queue.toString();
    }
    const url = this.apiUrl;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  public getItemPricingTemplate(visa: ApiVisa) {
    const url = visa.api_domain_url + this.endpoint_path + '/download-master-data-template';
    return this.httpClient.get(url, this.getHttpHeaderBlob(visa));
  }
}